const get = (key) => {
    const cookie = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith(`${key}=`))
        ?.split('=');
    return cookie && cookie.length === 2 ? decodeURIComponent(cookie[1]) : undefined;
};
const remove = (key) => {
    document.cookie = `${key}=;max-age=0;samesite=strict;path=/;secure`;
};
const set = (key, value, expirationDate) => {
    let cookie = encodeURIComponent(value);
    if (expirationDate !== undefined) {
        cookie += `;expires=${expirationDate.toUTCString()}`;
    }
    cookie += ';samesite=strict;path=/;secure';
    document.cookie = `${key}=${cookie}`;
};
export default {
    get,
    set,
    remove
};
//# sourceMappingURL=cookie.js.map